<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<p-panel header="{{ 'CENTRALRIESGO.LBL_CENRIESAGREGAR' | translate }}" *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6 lg:col-offset-3 md:col-offset-3">
            <div class="div-form">
              <label>{{'CENTRALRIESGO.LBL_INTEGRACIONES' | translate}}:</label>
              <p-dropdown disableTab  id="idIntegracion" name="nomIdIntegracion" [options]="lisIntegraciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idIntegracion"
                          (onChange)="verificarIntegracion()"
                          *ngIf="!exisIntegracion"
              ></p-dropdown>
              <label class="falso-combo-texto" *ngIf="exisIntegracion">{{ centralRiesgoIntegracion.integracion }}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idIntegracion.invalid">
                {{ 'CANALES.LBL_CANALES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-2 md:col-2 lg:col-2">
            <div class="div-form">
              <p-checkbox (onChange)="cambiarDiaVigencia()" formControlName="indicadorDiasVigencia" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_DIAVIGENCIA' | translate}}</label>
            </div>
          </div>
          <div class="col-3 md:col-3 lg:col-3 ">
            <div class="div-form">
              <input type="text" pInputText id="diasVigencia"
                     name="nomDiasVigencia"
                     autocomplete="off"
                     formControlName="diasVigencia"
                     numero-entero-reactive
                     [maxlength]="2"
                     capitalize-reactive
                     *ngIf="necesitaDiaVigencia"
              >
              <label class="falso-combo-texto" *ngIf="!necesitaDiaVigencia"></label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diasVigencia.invalid">
                {{ 'CENTRALRIESGO.LBL_DIAVIGENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-2 md:col-2 lg:col-2 ">
            <div class="div-form">
              <p-checkbox (onChange)="cambiarRangoVigencia()" formControlName="indicadorRango" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_RANGOVIGENCIA' | translate}}</label>
            </div>
          </div>
          <div class="col-3 md:col-3 lg:col-3 ">
            <div class="div-form">
              <input type="text" pInputText id="rangoVigencia"
                     name="nomRangoVigencia"
                     autocomplete="off"
                     formControlName="rangoVigencia"
                     numero-entero-reactive
                     [maxlength]="2"
                     capitalize-reactive
                     *ngIf="necesitaRangoVigencia"
              >
              <label class="falso-combo-texto" *ngIf="!necesitaRangoVigencia"></label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoVigencia.invalid">
                {{ 'CENTRALRIESGO.LBL_RANGOVIGENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-2 md:col-2 lg:col-2 ">
            <div class="div-form">
              <button style="width: 100%" type="button" pButton icon="fa fa-plus" label="{{'CENTRALRIESGO.BTN_AGREGARANGO' | translate }}"
                      (click)="agregarRango()" *ngIf="necesitaRangoVigencia"></button>
            </div>
          </div>
        </div>
        <div class="grid form-group" *ngIf="!ocuTabla">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <p-table [columns]="columnas" [loading]="carTabla" #dt
                       [value]="rangoDias" selectionMode="single" dataKey="idRangoDias"
                       [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                      {{col.header}}
                      <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr [pSelectableRow]="row">
                    <td class="text-center">{{row.dia}}</td>
                    <td class="text-center">
                      <div class="btn-group" role="group">
                        <button type="button" class="p-button p-button-success btn" icon="fa fa-trash-o" data-toggle="tooltip"
                                title="{{'BTN_ELIMINAR' | translate}}" pButton
                                (click)="eliminarDiaRango(row)"></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length">{{ 'MSG_NOHAYREGISTROS' | translate}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-4 md:col-4 lg:col-4 lg:col-offset-2 md:col-offset-2">
            <div class="div-form">
              <label>{{'CENTRALRIESGO.LBL_ESTADOBLOQUEADO' | translate}}:</label>
              <p-dropdown disableTab  id="idEstado" name="nomEstado" [options]="lisEstados"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                           formControlName="idEstado"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionLabel="label"
                          optionValue="value"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
                {{ 'CENTRALRIESGO.LBL_ESTADOBLOQUEADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-4 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{'CENTRALRIESGO.LBL_CORREOINFORMACION' | translate}}:</label>
              <input type="text" pInputText id="correo"
                     name="nomCorreo"
                     autocomplete="off"
                     formControlName="correo"
                     [maxlength]="128"
                     *ngIf="necesitaCorreo"
                     [appEmailSuggest]="true" [dominios]="dominios.dominios"

              >
              <label class="falso-combo-texto" *ngIf="!necesitaCorreo"></label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.correo.invalid">
                {{ 'CENTRALRIESGO.LBL_CORREOINFORMACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid text-center">
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorEncendido" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_ENCENDIDOANALIZAMOS' | translate}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorEncendido.invalid">
                {{ 'CENTRALRIESGO.LBL_ENCENDIDOANALIZAMOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorEncendidoAliado" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_ENCENDIDOALIADOS' | translate}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorEncendidoAliado.invalid">
                {{ 'CENTRALRIESGO.LBL_ENCENDIDOALIADOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorEncendidoPersonas" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_ENCENDIDOPERSONAS' | translate}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorEncendidoPersonas.invalid">
                {{'CENTRALRIESGO.LBL_ENCENDIDOPERSONAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorConsultaXSolicitud" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_CONSULTAXSOLICITUD' | translate}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorConsultaXSolicitud.invalid">
                {{ 'LBL_NUMERODOCUMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid text-center">
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorValidarPerfilRiesgo" binary="true"></p-checkbox>
              <label class="ml-2">{{'CENTRALRIESGO.LBL_VALIDARPERFIL' | translate}}</label>
            </div>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</p-panel>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
